import React, { useCallback, useEffect, useState } from "react";
import { Opponent } from "./Opponent";
import { GameClient } from "../gameClient";

/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Colors } from "../palettes/colorPalette";

declare var gameClient: GameClient;

interface OpponentInfoProps {
	playerId: number,
	// Player.ts: hp maxhp level name id numcells
	opponents: Array<[number, number, number, string, number, number]>
	hide: boolean;
}

const containerStyle = css`
	position: absolute;
	top: 50%;
    transform: translate(0, -50%);
	display: none;
	left: 0;
`;

const opponentInfoStyle = css`
    background-color: ${Colors.UIBackground};
    border-bottom-right-radius: 0.5vw;
    width: 11vw;
    padding: 1vw 0.5vw;
`;

const tabStyle = css`
	height: fit-content;
	background-color: ${Colors.UIBackground};
	padding: .25vw;
	border-top-right-radius: 0.5vw;
	border-bottom-right-radius: 0.5vw;
`;

export const OpponentInfo = ({ opponents, playerId, hide }: OpponentInfoProps) => {

	return (
		<div css={containerStyle} style={{ left: hide ? "-12vw" : "0" }}>
			<div css={opponentInfoStyle}>
				{
					opponents?.map(([hp, maxHp, level, name, id, cells], index) => (
						<div
							key={index}
							css={css`
					display: flex;
					flex-direction: column;
					align-items: center;
				`}
							onClick={() => gameClient.showPlayer(id)}
						>
							<span css={css`min-width: 2vw; margin-right: .5em; margin-left: .5em`}>{name}{playerId === id && ' (You)'}:</span>
							<Opponent hp={hp} maxHp={maxHp} cells={cells} />
						</div>
					))
				}
			</div>
			{
				/*
							<div css={tabStyle} onClick={toggleHide}>
								<FontAwesomeIcon icon={hidden ? faChevronLeft : faChevronRight} />
							</div>
				*/
			}
		</div>
	);
};

